module.exports = __webpack_public_path__ + "static/media/whatsapp.ebd09dd1.svg";